import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGeoMapData, IStoreBootstrap } from './types';
import {
  ICustomerPlanFieldsFragment,
  IFormatSettingFieldsFragment,
  IReportSettingFieldsFragment,
  ISchemaConfigFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import isEqual from 'lodash/isEqual';
import { toCustomerPlan } from './utils';

const initialState: IStoreBootstrap = {
  enabledFeatures: [],
  slackSupportLink: '',
  bootstrapLoaded: false,
  scheduleEmailDomains: [],
  defaultConfig: null,
  schemaConfig: null,
  permissionConfig: null,
  preventBasicEventMetadataUpdates: false,
  formatSetting: null,
  reportSetting: null,
  llmApiEnabled: false,
  customerPlan: {
    hasAvailableSchemas: true,
    reachMaxSeats: false,
  },
  customerName: '',
};

export default createSlice({
  name: 'bootstrap',
  initialState,
  reducers: {
    clearBootstrap: () => {
      return initialState;
    },
    loadBootstrap: (state, action: PayloadAction<IStoreBootstrap>) => {
      /* In case if bootstrap has been already loaded we should not modify it */
      if (!isEqual(state, initialState) && !isEqual(state, action.payload)) {
        throw Error('Do not edit bootstrap state');
      }
      return action.payload;
    },
    updateSchemaConfig: (
      state,
      action: PayloadAction<ISchemaConfigFieldsFragment>,
    ) => {
      state.schemaConfig = action.payload;
    },

    setFormatSetting: (
      state,
      action: PayloadAction<IFormatSettingFieldsFragment>,
    ) => {
      state.formatSetting = action.payload;
    },

    setGeoMapData: (state, action: PayloadAction<IGeoMapData>) => {
      state.geoMapData = action.payload;
    },
    updateReportSetting: (
      draft,
      action: PayloadAction<IReportSettingFieldsFragment>,
    ) => {
      draft.reportSetting = action.payload;
    },
    updateLlmApiEnabled: (draft, action: PayloadAction<boolean>) => {
      draft.llmApiEnabled = action.payload;
    },
    updateCustomerPlan: (
      state,
      action: PayloadAction<ICustomerPlanFieldsFragment>,
    ) => {
      state.customerPlan = toCustomerPlan(action.payload);
    },
  },
});
